import superiorDireito from "../../assets/superiorDireito.png";
import inferiorDireito from "../../assets/inferiorDireito.png";
import centroEsquerdo from "../../assets/centroEsquerdo.png";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import style from "./Login.module.css";
import { useState, useEffect } from "react";
import Logo from "../../assets/logoItera.png";
import UsuarioApi from "../../services/UsuarioApi";
import Alerta from "../../components/alerta/Alerta";
import Cookies from "js-cookie";
import Loader from "../../components/loader/Loader";
import Criptografia from "../../services/Criptografia";
import InputEntrar from "../../components/inputEntrar/InputEntrar";

export default function Login() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");
  const [loading, setLoading] = useState(false);

  const exibirAlerta = () => {
    setMostrarAlerta(true);
    setTimeout(() => {
      setMostrarAlerta(false);
    }, 3000);
  };

  useEffect(() => {
    const tokenString = Cookies.get('token');
    if (tokenString) {
      try {
        const token = JSON.parse(tokenString);

        const grupo = Number(Criptografia.DescriptografarID(token.grupoDeUsuarioId));
        const primeiroLogin = token.primeiroLogin;

        if (!primeiroLogin) {
          if ([2, 3, 4].includes(grupo)) {
            window.location.href = `${process.env.REACT_APP_SITE_PORTAL}`;
          } else if (grupo === 1) {
            window.location.href = `${process.env.REACT_APP_SITE_ADMIN}`;
          }
        }

      } catch {

      }
    }
  }, []);

  async function BotaoLogin() {
    setLoading(true);
    try {
      const response = await UsuarioApi.loginAsync(email, senha);
      setSenha("");

      const grupo = Number(response.grupodeUsuario);
      //Verifica se o usuario é Monitor, Cordenador ou Aluno
      if (
        grupo === 2 ||
        grupo === 3 ||
        grupo === 4
      ) {
        //Redirecionar para a tela de redefinição de senha caso seja o primeiro login
        if (response.primeiroLogin) {
          setMensagemAlerta(
            `Redefina seus dados!`
          );
          setTipoAlerta("success");
          exibirAlerta(true);

          setTimeout(() => {
            window.location.href = "/redefinirInformacoes";
          }, 1000);
          setLoading(false);
        }
        // edirecionar para a o portal do aluno de senha caso seja o primeiro login
        else {
          const tokenCookie = Cookies.get("token");

          sessionStorage.setItem("alertaLogado", "true");

          //Redirecionar para o Portal
          window.location.href = `${process.env.REACT_APP_SITE_PORTAL}?alert=logado_sucesso`;
          setLoading(false);
        }
      }
      //Verifica se o usuario é Administrator
      else if (grupo === 1) {

        if (response.primeiroLogin) {
          setMensagemAlerta(`Redefina sua senha!`);
          setTipoAlerta("success");
          exibirAlerta(true);

          setTimeout(() => {
            //Redirecionar para o BackOffice
            window.location.href = "redefinir/senha";
          }, 1000);
          setLoading(false);
        }
        else {


          //Redirecionar para o BackOffice

          window.location.href = `${process.env.REACT_APP_SITE_ADMIN}?alert=logado_sucesso`;
          // alert passado pela Url
          setLoading(false);
        }
      }
      //Caso não seja nenhum tipo de usuario acima o usuario não tem permissão de entrar no sistema
      else {
        setMensagemAlerta(
          `Você não possui permissão para acessar este portal.`
        );
        setTipoAlerta("danger");
        exibirAlerta(true);
        setLoading(false);
      }
    } catch (error) {
      const mensagemErro =
        error.response && error.response.data
          ? `Erro ao tentar logar: ${error.response.data}`
          : `Erro ao tentar logar: ${error.message}`;
      setMensagemAlerta(mensagemErro);
      setTipoAlerta("danger");
      exibirAlerta(true);
      setLoading(false);
    }
  }

  return (
    <div className={style.conteudo}>
      {loading && <Loader />}

      <Alerta
        tipo={tipoAlerta}
        mensagem={mensagemAlerta}
        visivel={mostrarAlerta}
        aoFechar={() => setMostrarAlerta(false)}
      />
      <div className={style.conteudo_esquerda}>
        <img
          src={centroEsquerdo}
          alt="centroEsquerdo"
          className={style.centro_esquerdo}
        />
      </div>
      <div className={style.conteudo_login}>
        <img src={Logo} alt="logo" className={style.imagem_logo} />
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            BotaoLogin();
          }}
        >
          <Form.Group className="mb-3" controlId={style.campos_email}>
            <InputEntrar
              type="email"
              placeholder="e-mail"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              maxLength={100}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId={style.campos_senha}>
            <InputEntrar
              type="password"
              placeholder="senha"
              name="senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              maxLength={50}
              required
            />
          </Form.Group>

          <Button variant="primary" type="submit" id={style.botao_entrar}>
            Entrar
          </Button>
        </Form>
        <Link to="/esqueciSenha" className={style.esqueci_minha_senha}>
          esqueci minha senha
        </Link>
      </div>
      <div className={style.conteudo_direita}>
        <img
          src={superiorDireito}
          alt="superiorDireito"
          className={style.superior_direito}
        />
        <img
          src={inferiorDireito}
          alt="inferiorDireito"
          className={style.inferior_direito}
        />
      </div>
    </div>
  );
}
